module.exports = __webpack_public_path__ + "img/event-2.2bc419d2.png";